module.exports = __webpack_public_path__ + "static/media/union.ab05e9da.svg";